import React from "react"

const MorningApptBanner = () => (
  <section>
    <div className="consent-announcement">
      <img
        alt="warning-circle.svg"
        height="24"
        src="/images/WarningCircle.svg"
        width="24"
      />
      We have immediate availability for morning ABA sessions (8am-12pm) at most
      centers
    </div>
  </section>
)

export default MorningApptBanner
